import axios from 'axios';
import {notifyVerificationRequired} from '@utils/verification';

// export const devBaseUrl = 'https://api.tyrebase.ru/api';
export const devBaseUrl = 'http://localhost/api';
export const prodBaseUrl = 'https://api.tyrebase.ru/api';



export const api = axios.create({
    baseURL: process.env.NODE_ENV === 'development' ? devBaseUrl : prodBaseUrl,
});
//api.defaults.headers.common.accept = 'application/json';

api.interceptors.response.use(response => response, error => {
    notifyVerificationRequired(error?.response?.status, error?.response?.data);
    return Promise.reject(error);
});
